module.exports = __webpack_public_path__ + "img/bronze-vip.fce63f04.svg";